module.exports = __webpack_public_path__ + "img/icon-auto-registration4.58f67a06.svg";